import React from 'react'
import styles from './Toolbar.module.css'
import { Link } from 'react-router-dom'

const Toolbar = props => {
  return (
    <nav className={styles.toolbar}>
      <div className={styles.toolbar_container}>
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link className={styles.stats} to="/stats">Stats</Link></li>
          <li><a href="/play">(Re)Start Game</a></li>
        </ul>
      </div>
    </nav>
  )
}

export default Toolbar
